import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppFloatingIcon() {
  return (
    <a
      href="https://wa.me/918848207990"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 right-4 z-[999] bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-xl transition duration-300 ease-in-out block"
    >
      <FaWhatsapp className="text-2xl sm:text-3xl" />
    </a>
  );
}
